export const EVENT = 'eventType';
export const VALUE = 'value';
